$(->
  # ADMIN > BUG REPORTS
  
  ## "Is this client facing?" dropdown
  $(document).on 'change', '#bug_report_issue_type', ->
    if $('#bug_report_issue_type').val() == 'internal'
      $('.js-client-facing-fields').addClass('hidden')
    else
      $('.js-client-facing-fields').removeClass('hidden')
      false

)
